




























































































































































































































































/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-len */
import {
  Component, Vue, Watch, Prop,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import { User } from '@/libs/api.interfaces';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import Doughnut from '@/components/Chart/Doughnut.vue';
import Apex from '@/components/Chart/Apex.vue';
import Table from '@/components/Chart/Table.vue';
import Select from '@/components/Select.vue';
import Select2 from '@/components/Select2.vue';
import SearchField from '@/components/SearchField.vue';
import Bar from '@/components/Chart/Bar.vue';
import Box from '@/components/HomeBox.vue';
import FormInput from '@/components/FormInput.vue';
import DatePicker, { DateRange } from '@/components/DatePicker.vue';
import api from '@/libs/api';
import dayjs from 'dayjs';
import Loader from '@/components/Loader.vue';
import numberFormat from '@/libs/numberFormat';
import VueMonthlyPicker from 'vue-monthly-picker';
import CalendarIcon from '@/assets/calendar.svg';
import SandBox from '@/components/SandBoxHome.vue';
import Modal from '@/components/Modal.vue';
import FirstTime from '@/components/ModalContent/FirstTime.vue';
import PaymentMethod from '@/components/ModalContent/PaymentMethod.vue';
import InactiveUser from '@/components/InactiveUser.vue';

@Component({
  components: {
    SearchField,
    LayoutTitle,
    LayoutContent,
    Doughnut,
    Bar,
    VueMonthlyPicker,
    Select,
    Box,
    DatePicker,
    Loader,
    FormInput,
    CalendarIcon,
    Apex,
    Table,
    Select2,
    SandBox,
    Modal,
    FirstTime,
    PaymentMethod,
    InactiveUser,
  },
  methods: {
    numberFormat,
  },
  computed: mapState(['user']),
})
export default class Home extends Vue {
  user!: {
    user: User;
  };

  @Prop({ default: 'default' }) readonly size!: string;
  monthpick = false;
  paymentDate: DateRange = {
    startDate: dayjs(dayjs().hour(0).minute(0).second(0)
      .subtract(1, 'day')).format('YYYY-MM-DD  00:00:00'),
    endDate: dayjs(dayjs().hour(0).minute(0).second(0)
      .subtract(1, 'day')).format('YYYY-MM-DD  23:59:59'),
  }

  env = process.env.VUE_APP_ENVIRONMENT;
  loading = true;
  loadingCard = false;
  loadingTraffic = true;
  loadingAmount = true;
  loadingStatus = true;
  date = {
    from: null,
    to: null,
    month: null,
    year: null,
  }

  numberFormat!: typeof numberFormat;

  accountActive = true
  environment = process.env.VUE_APP_ENVIRONMENT || '';
  modalFirstTime = false;
  modalPayment = false

  channel: null | LabelValue = null;
  amountSuccess = '';
  transactionSuccess = '';
  amountChannel = [];
  amountData = [];
  amountOutstandingChannel = [];
  amountOutstandingData = [];
  amountOthers = '';
  trafficChannel = [];
  selectedAmount = [];
  selectedTraffic = [];
  selectedStatus: null | LabelValue = null;
  updateChart2 = [];
  trafficData = [];
  all = [];
  val = false;
  selectedChannel: null | LabelValue = null;
  selectedBox: null | LabelValue = null;
  totalOutstanding = ''
  status: any[] = []
  summaryMonth = '';
  monthOutStanding = dayjs().format('YYYY-MM');
  statusBoarding = '';
  requested = false
  locale = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

  toggleModal() {
    this.modalFirstTime = !this.modalFirstTime;
    this.modalPayment = !this.modalPayment;
  }

  requestActivate() {
    this.requested = true;
    api.get('/mail/request-dp');
  }

  close(value: boolean) {
    this.modalFirstTime = value;
  }

  summaryTrafficOption = {
    label: 'All Status',
    value: 'all',
  };

  trafficOptions = [
    {
      label: 'Total Transaction Success',
      value: '00',
    },
    {
      label: 'Total Transaction Failed',
      value: '02',
    },
    {
      label: 'Total Transaction Time Out',
      value: '03',
    },
  ];

  amountOptions = [
    {
      label: 'Total Amount Success',
      value: '00',
    },
    {
      label: 'Total Amount Failed',
      value: '02',
    },
    {
      label: 'Total Amount Time Out',
      value: '03',
    },
  ];

  channelCodes: any = []
  channel1: any = [];

  handleSearchChannelCode(search: string) {
    this.channelCodes = this.channel1.filter((e: any) => e.label.toLowerCase().includes(search));
  }

  onBlur() {
    this.channelCodes = this.channel1;
  }

  async checkBoarding() {
    const params = this.$route.query;
    const statusStorage = localStorage.getItem('statusBoarding');
    if (!statusStorage) {
      try {
        const { data } = await api.get('/boarding-check');
        this.statusBoarding = data.boarding_form_complete.toString();

        localStorage.setItem('statusBoarding', this.statusBoarding);
        if (params.boarding === 'true') {
          this.modalFirstTime = false;
        } else if (this.environment === 'sandbox') {
          if (this.statusBoarding === 'false' && statusStorage !== 'true') {
            this.modalFirstTime = true;
          }
        }
      } catch (err) {
        console.error(err);
      }
    } else {
      this.statusBoarding = statusStorage;
    }
  }

  async getMonth() {
    if (this.user.user.is_internal !== 0) {
      try {
        this.loading = true;
        const month = dayjs(this.monthOutStanding.toString()).format('YYYY-MM');
        const getLast = dayjs(month).hour(0).minute(0).second(0)
          .subtract(1, 'month');
        const lastMonth = dayjs(getLast.toString()).format('YYYY-MM');
        const { data } = await api.get('/transaction/chart/outstanding', {
          params: {
            startDate: lastMonth,
            endDate: month,
          },
        });
        this.all = data.data;
        this.totalOutstanding = data.total_outstanding;
        this.loading = false;
      } catch (err) {
        console.error(err);
      }
    }
  }

  async getChart() {
    try {
      this.loading = true;
      this.loadingTraffic = true;
      this.loadingAmount = true;
      this.loadingStatus = true;
      this.loadingCard = true;
      const now2 = dayjs().format('YYYY-MM-DD  HH:mm:ss');
      const getLast7Day = dayjs().hour(0).minute(0).second(0)
        .subtract(1, 'day');
      const last7Day = dayjs(getLast7Day).format('YYYY-MM-DD  HH:mm:ss');
      const { data } = await api.get('/transaction/chart', {
        params: {
          paymentStartDate: this.paymentDate.startDate === null ? last7Day : dayjs(this.paymentDate.startDate).format('YYYY-MM-DD 00:00:00'),
          paymentEndDate: this.paymentDate.endDate === null ? now2 : dayjs(this.paymentDate.endDate).format('YYYY-MM-DD 23:59:59'),
          flagStatus: '00',
        },
      });

      this.transactionSuccess = data.summary.total_transaction !== 0 ? numberFormat(parseFloat(data.summary.total_transaction)) : '';
      this.amountSuccess = data.summary.total_amount !== 0 ? numberFormat(data.summary.total_amount, true) : '';

      this.trafficChannel = data.summary.traffic !== null ? data.summary.traffic.map((e: any) => e.channel) : [];
      this.trafficData = data.summary.traffic !== null ? data.summary.traffic.map((e: any) => e.total) : [];

      this.amountChannel = data.summary.amount !== null ? data.summary.amount.map((e: any) => e.channel) : [];
      this.amountData = data.summary.amount !== null ? data.summary.amount.map((e: any) => e.total) : [];

      this.val = !this.val;
      if (data.summary.status.success !== 0 || data.summary.status.failed !== 0) {
        this.status = [];
        this.status.push(data.summary.status.success, data.summary.status.failed);
      }

      // this.status.map(data.summary.status.success, data.summary.status.failed);
      //  value: '00',
      // this.changeBox(this.trafficOptions[0]);
      this.loading = false;
      this.loadingTraffic = false;
      this.loadingAmount = false;
      this.loadingStatus = false;
      this.loadingCard = false;
    } catch (err) {
      console.error(err);
    }
  }

  async getChannelCodes() {
    try {
      this.loading = true;
      const { data } = await api.get('/merchant/service');
      this.channelCodes = Object.keys(data)
        .map((key: string) => ({
          label: data[key],
          value: key,
        }))
        .sort((a, b) => {
          const textA = a.label.toUpperCase();
          const textB = b.label.toUpperCase();
          if (textA < textB) {
            return -1;
          }
          if (textA > textB) {
            return 1;
          }
          return 0;
        });
      this.channel1 = this.channelCodes;
      this.loading = false;
    } catch (err) {
      console.error(err);
    }
  }

  async getCard() {
    this.loadingCard = true;
    try {
      this.loading = true;
      const now2 = dayjs().format('YYYY-MM-DD  HH:mm:ss');
      const { data } = await api.get('/transaction/chart', {
        params: {
          paymentStartDate: this.paymentDate.startDate === null ? '2015-09-11 00:00:00' : dayjs(this.paymentDate.startDate).format('YYYY-MM-DD 00:00:00'),
          paymentEndDate: this.paymentDate.endDate === null ? now2 : dayjs(this.paymentDate.endDate).format('YYYY-MM-DD 23:59:59'),
          'serviceChannel[]': this.channel === null ? null : this.channel.value,
          flagStatus: this.selectedChannel !== null ? this.selectedChannel.value : '00',
        },
      });
      this.loadingCard = false;
      this.transactionSuccess = numberFormat(data.summary.total_transaction);
      this.amountSuccess = numberFormat(data.summary.total_amount, true);

      this.loading = false;
    } catch (err) {
      console.error(err);
    }
  }

  async getChartTraffic2() {
    setTimeout(() => {
      this.getChartTraffic();
    }, 400);
  }

  async getChartTraffic() {
    try {
      this.loadingTraffic = true;
      const now2 = dayjs().format('YYYY-MM-DD  HH:mm:ss');
      const getLast7Day = dayjs().hour(0).minute(0).second(0)
        .subtract(1, 'day');
      const last7Day = dayjs(getLast7Day).format('YYYY-MM-DD  HH:mm:ss');
      const { data } = await api.get('/transaction/chart', {
        params: {
          paymentStartDate: this.paymentDate.startDate === null ? last7Day : dayjs(this.paymentDate.startDate).format('YYYY-MM-DD 00:00:00'),
          paymentEndDate: this.paymentDate.endDate === null ? now2 : dayjs(this.paymentDate.endDate).format('YYYY-MM-DD 23:59:59'),
          trafficChartOnly: true,
          serviceChannel: this.selectedTraffic !== null ? this.selectedTraffic.map((e: any) => e.value) : null,
        },
      });
      if (data.summary.traffic !== null) {
        this.trafficChannel = data.summary.traffic.map((e: any) => e.channel);
        this.trafficData = data.summary.traffic.map((e: any) => e.total);
      } else {
        this.trafficChannel = [];
        this.trafficData = [];
      }
      this.loadingTraffic = false;
    } catch (err) {
      console.error(err);
    }
  }

  async getChartAmount2() {
    setTimeout(() => {
      this.getChartAmount();
    }, 400);
  }

  async getChartAmount() {
    this.loadingAmount = true;
    const now2 = dayjs().format('YYYY-MM-DD  HH:mm:ss');
    const getLast7Day = dayjs().hour(0).minute(0).second(0)
      .subtract(1, 'day');
    const last7Day = dayjs(getLast7Day).format('YYYY-MM-DD  HH:mm:ss');
    const { data } = await api.get('/transaction/chart', {
      params: {
        paymentStartDate: this.paymentDate.startDate === null ? last7Day : dayjs(this.paymentDate.startDate).format('YYYY-MM-DD 00:00:00'),
        paymentEndDate: this.paymentDate.endDate === null ? now2 : dayjs(this.paymentDate.endDate).format('YYYY-MM-DD 23:59:59'),
        amountChartOnly: true,
        serviceChannel: this.selectedAmount !== null ? this.selectedAmount.map((e: any) => e.value) : null,
      },
    });

    if (data.summary.amount !== null) {
      this.amountChannel = data.summary.amount.map((e: any) => e.channel);
      this.amountData = data.summary.amount.map((e: any) => e.total);
    } else {
      this.amountChannel = [];
      this.amountData = [];
    }
    this.loadingAmount = false;
  }

  async getChartStatus(val: any) {
    if (val === 'apply') {
      try {
        this.loadingStatus = true;
        const now2 = dayjs().format('YYYY-MM-DD  HH:mm:ss');
        const getLast7Day = dayjs().hour(0).minute(0).second(0)
          .subtract(1, 'day');
        const last7Day = dayjs(getLast7Day).format('YYYY-MM-DD  HH:mm:ss');
        const { data } = await api.get('/transaction/chart', {
          params: {
            paymentStartDate: this.paymentDate.startDate === null ? last7Day : dayjs(this.paymentDate.startDate).format('YYYY-MM-DD 00:00:00'),
            paymentEndDate: this.paymentDate.endDate === null ? now2 : dayjs(this.paymentDate.endDate).format('YYYY-MM-DD 23:59:59'),
            flagStatus: val.value,
            'serviceChannel[]': this.selectedStatus !== null ? this.selectedStatus.value : null,
          },
        });
        this.status = [];
        this.status.push(data.summary.status.success, data.summary.status.failed);
        this.loadingStatus = false;
      } catch (err) {
        console.error(err);
      }
    }
  }

  async changeBox(value: any) {
    if (value !== null) {
      this.selectedChannel = value;
      const now2 = dayjs().format('YYYY-MM-DD  HH:mm:ss');
      const getLast7Day = dayjs().hour(0).minute(0).second(0)
        .subtract(1, 'day');
      const last7Day = dayjs(getLast7Day).format('YYYY-MM-DD  HH:mm:ss');
      try {
        const { data } = await api.get('/transaction/chart', {
          params: {
            paymentStartDate: this.paymentDate.startDate === null ? last7Day : dayjs(this.paymentDate.startDate).format('YYYY-MM-DD 00:00:00'),
            paymentEndDate: this.paymentDate.endDate === null ? now2 : dayjs(this.paymentDate.endDate).format('YYYY-MM-DD 23:59:59'),
            flagStatus: this.selectedChannel?.value,
            'serviceChannel[]': this.channel !== null ? this.channel.value : null,
          },
        });
        // this.selectedBox = value;
        this.transactionSuccess = numberFormat(data.summary.total_transaction);
        this.amountSuccess = numberFormat(data.summary.total_amount, true);
        this.loading = false;
      } catch (err) {
        console.error(err);
      }
    } else {
      this.loading = false;
    }
  }

  @Watch('paymentDate.startDate')
  async chartDate() {
    this.channel = null;
    this.selectedChannel = null;
    this.getChart();
  }

  @Watch('monthOutStanding')
  chartOutstandingDate() {
    this.getMonth();
  }

  @Watch('channel')
  async updateChart() {
    this.getCard();
  }

  mounted() {
    if (this.environment === 'sandbox' && !this.user.user.is_internal) {
      this.checkBoarding();
    }

    this.getChart();
    this.getMonth();
    this.getChannelCodes();
  }
}
